import {combineReducers} from 'redux';

import api from 'utils/api';

const SET_SELECTED = 'categories/SET_SELECTED';
const RECEIVE_CATEGORIES = 'categories/RECEIVE_CATEGORIES';


const data = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_CATEGORIES:
            return action.results;

        default:
            return state;
    }
};

const selected = (state = null, action) => {
    switch (action.type) {
        case SET_SELECTED:
            return action.id;

        default:
            return state;
    }
};

// Add any extra reducer required for catalogue list
export default combineReducers({
    data,
    selected,
});

export const selectCategory = id => ({type: SET_SELECTED, id});
export const receiveCategories = results => ({type: RECEIVE_CATEGORIES, results});


export const fetchCategories = () => async (dispatch) => {
    const response = await api.categoryList.fetch();
    if (response) {
        dispatch(receiveCategories(response.results));
    }
};

export const getSelectedIds = (selectedId, children) => {
    const processChildren = (category) => {
        if (category.id === selectedId) {
            return [category.id];
        }

        const selectedChildred = getSelectedIds(selectedId, category.children);
        if (selectedChildred.length) {
            return [category.id, ...selectedChildred];
        }

        return [];
    };

    const selectedCategories = [].concat(...children.map(processChildren));
    return selectedCategories;
};



// WEBPACK FOOTER //
// ./src/ducks/categories.js